import React from 'react';
import { PionType } from '../../../type';
import Typography from '../../Typography';

import './pion-content-brand.scss';

type PionBrandContentPropsType = {
  pion: PionType;
};

const PionBrandContent = ({ pion }: PionBrandContentPropsType) => (
  <div className='pion-content-brand'>
    <div className='pion-content-brand__title'>
      <Typography
        component='span'
        variant={Typography.THEME.VARIANTS.TITLE_NORMAL}
      >
        {pion.get('brand')}
      </Typography>
    </div>
    <div className='pion-content-brand__model'>
      <Typography
        component='span'
        variant={Typography.THEME.VARIANTS.TITLE_SMALL}
      >
        {pion.get('model')}
      </Typography>
    </div>

    {!!pion.get('pionInfo') && (
      <div className='pion-content-brand__info'>{pion.get('pionInfo')}</div>
    )}

    {!!pion.get('serial') && (
      <div className='pion-content-brand__info'>{pion.get('serial')}</div>
    )}
  </div>
);

export default PionBrandContent;
